import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LayoutDashboard, FilePlus2, Mail, LogOut, Globe, Users } from "lucide-react";
import { LogoMark } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { label: "Panel", path: "/redaccion-nexodum", icon: LayoutDashboard, testid: "admin-nav-panel" },
  { label: "Nuevo artículo", path: "/redaccion-nexodum/nuevo", icon: FilePlus2, testid: "admin-nav-nuevo" },
  { label: "Redacción", path: "/redaccion-nexodum/usuarios", icon: Users, testid: "admin-nav-usuarios", perm: "manage_users" },
  { label: "Mensajes", path: "/redaccion-nexodum/mensajes", icon: Mail, testid: "admin-nav-mensajes" },
];

export default function AdminLayout({ children, title }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout, can } = useAuth();

  const doLogout = async () => { await logout(); navigate("/redaccion-nexodum/login"); };
  const navItems = NAV.filter((n) => !n.perm || can(n.perm));

  return (
    <div className="min-h-screen flex bg-[#F4F5F7]" data-testid="admin-layout">
      <aside className="w-64 bg-nx-dark text-white flex flex-col fixed h-screen">
        <div className="p-5 border-b border-white/10 flex items-center gap-2.5">
          <LogoMark size={34} />
          <div>
            <p className="font-black text-sm leading-none">NEXODUM</p>
            <p className="text-[9px] uppercase tracking-widest text-slate-400 mt-1">Redacción</p>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {navItems.map((n) => {
            const Icon = n.icon;
            const active = n.path === "/admin" ? location.pathname === "/admin" : location.pathname.startsWith(n.path);
            return (
              <Link key={n.path} to={n.path} data-testid={n.testid}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${active ? "bg-nx-orange text-white" : "text-slate-300 hover:bg-white/5"}`}>
                <Icon size={17} />{n.label}
              </Link>
            );
          })}
        </nav>
        <div className="p-3 border-t border-white/10">
          <Link to="/" target="_blank" className="flex items-center gap-3 px-3 py-2.5 rounded-md text-sm text-slate-300 hover:bg-white/5" data-testid="admin-view-site">
            <Globe size={17} />Ver sitio
          </Link>
          <div className="px-3 py-2 text-xs text-slate-500">
            <p className="text-slate-300 font-semibold">{user?.name}</p>
            <p className="uppercase tracking-wider">{user?.role}</p>
          </div>
          <button onClick={doLogout} data-testid="admin-logout"
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-sm text-red-300 hover:bg-red-500/10 transition-colors">
            <LogOut size={17} />Cerrar sesión
          </button>
        </div>
      </aside>

      <div className="flex-1 ml-64">
        <header className="bg-white border-b border-gray-200 h-16 flex items-center px-8 sticky top-0 z-10">
          <h1 className="font-serif font-black text-xl text-nx-dark">{title}</h1>
        </header>
        <main className="p-8">{children}</main>
      </div>
    </div>
  );
}
